import styled from 'styled-components';
import { theme } from '../styles/theme';
import { Card, Flex } from '../styles';

// Avatar customizado para o Dashboard
export const DashboardAvatar = styled.div<{ type?: 'admin' | 'operador' }>`
  width: 60px;
  height: 60px;
  background: ${props => props.type === 'admin' 
    ? `linear-gradient(135deg, ${theme.colors.warning[400]} 0%, ${theme.colors.warning[600]} 100%)` 
    : `linear-gradient(135deg, ${theme.colors.primary[400]} 0%, ${theme.colors.primary[600]} 100%)`};
  border-radius: ${theme.borderRadius.full};
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${theme.colors.text.inverse};
  font-weight: ${theme.typography.fontWeight.semibold};
  font-size: ${theme.typography.fontSize.xl};
`;

// Container para informações do usuário
export const UserInfo = styled(Flex)`
  align-items: center;
  gap: ${theme.spacing[4]};
  margin-bottom: ${theme.spacing[5]};
`;

export const UserDetails = styled.div`
  h3 {
    margin: 0 0 ${theme.spacing[1]} 0;
    color: ${theme.colors.text.primary};
    font-size: ${theme.typography.fontSize.lg};
    font-weight: ${theme.typography.fontWeight.semibold};
  }
  
  p {
    margin: 0;
    color: ${theme.colors.text.secondary};
    font-size: ${theme.typography.fontSize.sm};
  }
`;

// Badge personalizado para tipo de usuário
export const UserTypeBadge = styled.span<{ type: 'admin' | 'operador' }>`
  display: inline-block;
  padding: ${theme.spacing[1]} ${theme.spacing[3]};
  border-radius: ${theme.borderRadius.full};
  font-size: ${theme.typography.fontSize.xs};
  font-weight: ${theme.typography.fontWeight.semibold};
  text-transform: uppercase;
  background: ${props => props.type === 'admin' ? theme.colors.warning[100] : theme.colors.primary[100]};
  color: ${props => props.type === 'admin' ? theme.colors.warning[700] : theme.colors.primary[700]};
  margin-top: ${theme.spacing[2]};
`;

// Grid para ações rápidas
export const QuickActionsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: ${theme.spacing[5]};
  margin-top: ${theme.spacing[8]};
`;

// Card de ação customizado
export const ActionCard = styled(Card)`
  cursor: pointer;
  transition: all ${theme.transitions.normal};

  &:hover {
    transform: translateY(-4px);
    box-shadow: ${theme.shadows.lg};
  }

  h4 {
    margin: 0 0 ${theme.spacing[2]} 0;
    color: ${theme.colors.text.primary};
    font-size: ${theme.typography.fontSize.lg};
    font-weight: ${theme.typography.fontWeight.semibold};
  }

  p {
    margin: 0;
    color: ${theme.colors.text.secondary};
    font-size: ${theme.typography.fontSize.sm};
    line-height: ${theme.typography.lineHeight.relaxed};
  }
`;
